export enum EService {
  /** Бесплатное **/
  Free = 'free',
  /** <a href="http://www.cian.ru/promo/adv/#color" target="_blank">Выделение цветом</a> **/
  Highlight = 'highlight',
  /** Платное **/
  Paid = 'paid',
  /** <a href="http://www.cian.ru/promo/adv/#premium" target="_blank">Премиум-объявление</a> **/
  Premium = 'premium',
  /** <a href="http://www.cian.ru/promo/adv/#top3" target="_blank">Топ 3</a> **/
  Top3 = 'top3',
  /** Подмена номера, Calltracking, оно же "защита номера" **/
  Calltracking = 'calltracking',
  /** Аукцион **/
  Auction = 'auction',
}
